import { IdModal } from "../../modals/IdModal";
import { createPathSelectTabInModal } from "./createPathSelectTabInModal";
export var pathOpenShopOffers = function (action, state$, deps) { return createPathSelectTabInModal(function () { return IdModal.Shop; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathOpenShopOffers.ts
// module id = 2364
// module chunks = 3